import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    cookieAllowState: '',
    isNeedReturnToOAuth2: false,
    oauth2Data: {},
    redirectUri: '',
    isCallback: false,
    isLoadTransitioned: false,
  },

  getters: {
    cookieAllowState(state) {
      return state.cookieAllowState;
    },

    isNeedReturnToOAuth2(state) {
      return state.isNeedReturnToOAuth2;
    },

    oauth2Data(state) {
      return state.oauth2Data;
    },

    redirectUri(state) {
      return state.redirectUri;
    },

    isCallback(state) {
      return state.isCallback;
    },

    isLoadTransitioned(state) {
      return state.isLoadTransitioned;
    },
  },

  mutations: {
    changeCookieAllowState(state, cookieState) {
      state.cookieAllowState = cookieState;
    },

    setNeedReturnToOAuth2(state, isNeed) {
      state.isNeedReturnToOAuth2 = isNeed;
    },

    saveOauth2Data(state, data) {
      state.oauth2Data = data;
    },

    setRedirectUri(state, uri) {
      state.redirectUri = uri;
    },

    setIsCallback(state, uri) {
      state.isCallback = uri;
    },

    setLoadTransition(state, isTransition) {
      state.isLoadTransitioned = isTransition;
    },
  },
});
